// import IMask from 'imask';
import validator from "validator";

export default class validation {
  constructor(errorsContainer) {
    this.disallow_nums = /[0-9\/]+/;
    this.options = errorsContainer;
  }

  /**
   *
   * @param type
   * @param selector
   */
  validate(type, selector) {
    switch (type) {
      case "firstName":
      case "lastName":
      case "billingCity":
        this.firstName(selector);
        break;
      case "post":
        this.post(selector);
        break;
      case "text":
        this.text(selector);
        break;
      case "phone":
        this.phone(selector);
        break;
      case "password":
        this.password(selector);
        break;
      case "email":
        this.email(selector);
        break;
      case "submit":
        this.submit(selector);
    }
  }

  strError(errorText) {
    // console.log(errorText);
    const lang = document.documentElement.getAttribute("lang");
    // console.log(lang);
    const str = {
      "en-GB": {
        "Email field is required": "Email field is required",
        "Phone field is required": "Phone field is required",
        "Name is required": "Name is required",
        "Text field is required": "Text field is required",
        "Password field is required": "Password field is required",
        "This field is required": "This field is required",
        "Invalid input format": "Invalid input format",
        "Password must be at least 6 characters long":
          "Password must be at least 6 characters long",
      },
      "en-US": {
        "Email field is required": "Email field is required",
        "Phone field is required": "Phone field is required",
        "Name is required": "Name is required",
        "Text field is required": "Text field is required",
        "Password field is required": "Password field is required",
        "This field is required": "This field is required",
        "Invalid input format": "Invalid input format",
        "Password must be at least 6 characters long":
          "Password must be at least 6 characters long",
      },
      "nb-NO": {
        "Email field is required": "E-postfelt er obligatorisk",
        "Phone field is required": "Telefonfelt er obligatorisk",
        "Name is required": "Navn er påkrevd",
        "Text field is required": "Tekstfelt er obligatorisk",
        "Password field is required": "Passordfelt er obligatorisk",
        "This field is required": "Dette feltet er obligatorisk",
        "Invalid input format": "Ugyldig inndataformat",
        "Password must be at least 6 characters long":
          "Passordet må være minst 6 tegn langt",
      },
    };

    return str[lang][errorText];
  }

  /**
   * Validate the empty fields before submit
   */
  submit(selector) {
    let checkout_form_submit = document.querySelector(selector);

    this.boundSubmitValidator = (e) =>
      this.submitValidator(e, checkout_form_submit);
    checkout_form_submit.addEventListener("click", this.boundSubmitValidator);
  }

  /**
   * Action submit handler
   * @param e
   * @param field
   */
  submitValidator(e, field) {
    let from = field.closest("form");
    for (let i = 0; i < from.length; i++) {
      if (from[i].hasAttribute("required") && from[i].value === "") {
        this.isValid(
          false,
          from[i],
          this.strError("Please fill out all fields")
        );
      }
    }

    if (from.querySelectorAll(".invalid").length) {
      e.preventDefault();
    }
  }

  password(selector) {
    let field = document.querySelector(selector);
    this.boundPasswordValidator = (e) => this.passwordStringValidator(e, field);
    field.addEventListener("keyup", this.boundPasswordValidator);
  }

  passwordStringValidator(e, field) {
    const value = e.target.value;

    // Check for empty value and minimum length
    let _isValid = value.length >= 6;

    // Error message
    let error_msg =
      value === ""
        ? this.strError("Password field is required")
        : this.strError("Password must be at least 6 characters long");

    // Updating validation state
    this.isValid(_isValid, field, error_msg);
  }

  text(selector) {
    let field = document.querySelector(selector);
    this.boundTextValidator = (e) => this.textStringValidator(e, field);
    field.addEventListener("keyup", this.boundTextValidator);
  }

  textStringValidator(e, field) {
    const value = e.target.value;
    // Regular expression for prohibited characters
    // const forbiddenChars = /[<>\/{}%&)(]/;

    // // Regular expression to check if a string contains only special characters longer than 4
    // const specialCharsOnly = /^[^a-zA-Z\u0400-\u04FF0-9]{5,}$/;

    // // Check for prohibited characters
    // let _isValid = !forbiddenChars.test(value);

    // if (_isValid) {
    //     _isValid = !specialCharsOnly.test(value);
    // }

    let _isValid = value.length >= 3;

    let error_msg =
      value === ""
        ? this.strError("Text field is required")
        : this.strError("Invalid input format");
    this.isValid(_isValid, field, error_msg);
  }

  /**
   * Field interaction handler: keydown, keyup
   * @param selector
   */
  firstName(selector) {
    let field = document.querySelector(selector);
    field.addEventListener("keydown", (event) => {
      if (this.disallow_nums.test(event.key)) {
        event.preventDefault();
      }
    });
    if (field.name === "name") {
      field.setAttribute("maxlength", "40");
    } else {
      field.setAttribute("maxlength", "20");
    }
    this.boundFirstNameValidator = (e) =>
      this.firstNameStringValidator(e, field);
    field.addEventListener("keyup", this.boundFirstNameValidator);
  }

  firstNameStringValidator(e, field) {
    // Defining Ignored Characters
    let ignore = { ignore: "-" };
    if (field.name === "name") {
      ignore = { ignore: "[\\s-]+" };
    }

    // Checking the validity of the entered data
    let value = e.target.value;
    let isValid = /^[a-zA-Z\u0400-\u04FF\s-]+$/.test(value); // Регулярное выражение для проверки всех букв кириллицы и латиницы, а также пробелов и дефисов

    // Generating an error message
    let error_msg =
      value === ""
        ? this.strError("Name is required")
        : this.strError("Invalid input format");
    this.isValid(isValid, field, error_msg);
  }

  /**
   * Phone number masking and validation
   * @param selector
   */
  phone(selector) {
    let field = document.querySelector(selector);
    // let maskOptions = {
    //     mask: {
    //         mask: '+{00}0000000000',
    //         startsWith: '',
    //         country: 'any',
    //         lazy: true
    //     }
    // };

    // IMask(field, maskOptions);
    // field.setAttribute("placeholder", "+ХХХХХХХХХХXX")
    this.boundPhoneStringValidator = (e) => this.phoneStringValidator(e, field);
    field.addEventListener("keyup", this.boundPhoneStringValidator);
  }

  phoneStringValidator(e, field) {
    let _value = e.target.value.replace(/[()-]/g, "");
    let _isValid = validator.isMobilePhone(_value, "any", { strict: true });
    let error_msg =
      e.target.value === ""
        ? this.strError("Phone field is required")
        : this.strError("Invalid input format");
    this.isValid(_isValid, field, error_msg);
  }

  /**
   * Email validation
   */
  email(selector) {
    let field = document.querySelector(selector);
    this.boundEmailStringValidation = (e) =>
      this.emailStringValidation(e, field);
    field.addEventListener("keyup", this.boundEmailStringValidation);
  }

  emailStringValidation(e, field) {
    let _isValid = validator.isEmail(e.target.value);
    let error_msg =
      e.target.value === ""
        ? this.strError("Email field is required")
        : this.strError("Invalid input format");
    this.isValid(_isValid, field, error_msg);
  }

  /**
   * The delivery filial ID
   * @param selector
   */
  post(selector) {
    let field = document.querySelector(selector);

    field.setAttribute("maxlength", "4");
    field.setAttribute("required", "");
    field.oninput = function (e) {
      e.target.value = e.target.value.replace(/[^0-9]/gi, "");
    };
    this.boundPostStringValidator = (e) => this.postStringValidator(e, field);
    field.addEventListener("keyup", this.boundPostStringValidator);
  }

  postStringValidator(e, field) {
    let _isValid = validator.isNumeric(e.target.value);
    let error_msg =
      e.target.value === ""
        ? this.strError("This field is required")
        : this.strError("Invalid input format");
    this.isValid(_isValid, field, error_msg);
  }

  /**
   * manage status classes and form submit
   * @param isValid
   * @param field
   * @param error_type
   */
  isValid(isValid, field, error_type) {
    const parent = field.closest(".c-input, .c-checkbox");
    if (isValid) {
      if (field.classList.contains("invalid")) {
        field.classList.replace("invalid", "valid");
      } else {
        field.classList.add("valid");
      }
      this.clearErrorMsg(field);

      if (parent && parent.classList.contains("is-invalid")) {
        parent.classList.remove("is-invalid");
      }
    } else {
      if (field.classList.contains("valid")) {
        field.classList.replace("valid", "invalid");
      } else {
        field.classList.add("invalid");
      }
      this.errorMsg(field, error_type);

      if (parent && !parent.classList.contains("is-invalid")) {
        parent.classList.add("is-invalid");
      }
    }
  }

  errorMsg(field, error_type) {
    // if (document.querySelector(this.errorsContainer).children() !== null && field.nextElementSibling.classList.contains('error-msg')) {
    //   field.nextElementSibling.remove()
    // }

    // console.log(document.querySelector(this.options.errorsContainer));
    // let error_node = document.createElement("div")
    // error_node.innerHTML = error_type
    // error_node.classList.add('error-msg')

    // console.log(document.querySelector(this.errorsContainer));
    // console.log(this.errorsContainer.errorsContainer);

    // field.insertAdjacentElement('afterend', error_node)
    //    console.log(field.name);
    const errorsContainer = document.querySelector(
      this.options.errorsContainer
    );

    const existingError = errorsContainer.querySelector(
      `[data-field="${field.name}"]`
    );
    if (existingError) {
      existingError.remove();
    }

    const errorNode = document.createElement("div");
    errorNode.innerHTML = error_type;
    errorNode.dataset.field = field.name;
    errorNode.classList.add("error-msg");

    errorsContainer.appendChild(errorNode);
  }

  clearErrorMsg(field) {
    // if (field.nextElementSibling !== null && field.nextElementSibling.classList.contains('error-msg')) {
    //   field.nextElementSibling.remove()
    // }

    const errorsContainer = document.querySelector(
      this.options.errorsContainer
    );
    const existingError = errorsContainer.querySelector(
      `[data-field="${field.name}"]`
    );
    if (existingError) {
      existingError.remove();
    }
  }
}
